// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-basket {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 50px;
}
.wrapper-basket .article-wrappers {
  flex-grow: 1;
  padding-top: 10px;
  overflow-y: auto;
  margin: 0 18px 18px;
  background: #fff;
  border-radius: 9px;
}

.footer {
  padding: 15px;
  width: 100%;
}
.footer ion-button {
  width: 100%;
  --border-width: 0;
  --border-style: none;
  font-family: var(--ion-font-family);
  padding: 3px;
}
.footer ion-button span {
  padding-top: 4px;
  text-transform: none;
}

.tips {
  padding-left: 15px;
  padding-right: 15px;
  border-bottom: 1px solid #383838;
  padding-bottom: 10px;
}

.total {
  padding: 0;
}
.total .total-title,
.total .total-sum {
  font-family: var(--ion-font-family);
  font-weight: 700;
  font-style: Bold;
  font-size: 18px;
  vertical-align: middle;
  text-transform: capitalize;
  color: #383838;
}
.total .total-title-dark {
  color: #fff !important;
  font-family: AppFontEintrachtOFCSans;
}
.total .total-sum-dark {
  color: #B3B6B9 !important;
  font-family: AppFontEintrachtOFCSans;
  font-weight: 400;
}

.button-row {
  padding: 10px 2px;
}
.button-row.eintracht {
  padding-top: 20px;
  padding-bottom: 20px;
}

.cross-icon {
  z-index: 5;
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 22px;
  height: 22px;
  padding: 0px;
  z-index: 99;
}
.cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}

.eintracht {
  --background: #282828;
  --color: #fff;
}

.sum-container {
  display: flex;
  align-items: center;
  gap: 3px;
}

ion-footer.eintracht {
  background: #282828;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout-modal/checkout-modal.component.scss"],"names":[],"mappings":"AACA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AAAD;AACC;EACC,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEC;EACC,aAAA;EACA,WAAA;AACF;AACE;EACC,WAAA;EACA,iBAAA;EACA,oBAAA;EACG,mCAAA;EACA,YAAA;AACN;AAAG;EACC,gBAAA;EACA,oBAAA;AAEJ;;AAGC;EACC,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,oBAAA;AAAF;;AAEA;EACC,UAAA;AACD;AACC;;EAEC,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;AACF;AAEI;EACE,sBAAA;EACH,oCAAA;AAAH;AAGI;EACE,yBAAA;EACH,oCAAA;EACA,gBAAA;AADH;;AAIA;EACC,iBAAA;AADD;AAEC;EACC,iBAAA;EACA,oBAAA;AAAF;;AAGA;EACC,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AADD;AAEC;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAAF;;AAIA;EACE,qBAAA;EACA,aAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIC;EACC,mBAAA;EACA,gBAAA;AADF","sourcesContent":["@import '../../../theme/mixins';\n.wrapper-basket {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tpadding-top: 50px;\n\t.article-wrappers {\n\t\tflex-grow: 1;\n\t\tpadding-top: 10px;\n\t\toverflow-y: auto;\n\t\tmargin: 0 18px 18px;\n\t\tbackground: #fff;\n\t\tborder-radius: 9px;\n\t}\n}\n\t.footer {\n\t\tpadding: 15px;\n\t\twidth: 100%;\n\n\t\tion-button {\n\t\t\twidth: 100%;\n\t\t\t--border-width: 0;\n\t\t\t--border-style: none;\n    \t\tfont-family: var(--ion-font-family);\n    \t\tpadding: 3px;\n\t\t\tspan {\n\t\t\t\tpadding-top: 4px;\n\t\t\t\ttext-transform: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t.tips {\n\t\tpadding-left: 15px;\n\t\tpadding-right: 15px;\n\t\tborder-bottom: 1px solid #383838;\n\t\tpadding-bottom: 10px;\n\t}\n.total {\n\tpadding: 0;\n\n\t.total-title,\n\t.total-sum {\n\t\tfont-family: var(--ion-font-family);\n\t\tfont-weight: 700;\n\t\tfont-style: Bold;\n\t\tfont-size: 18px;\n\t\tvertical-align: middle;\n\t\ttext-transform: capitalize;\n\t\tcolor: #383838;\n\t}\n\n    .total-title-dark {\n      color: #fff !important;\n\t  font-family: AppFontEintrachtOFCSans;\n    }\n\n    .total-sum-dark {\n      color: #B3B6B9 !important;\n\t  font-family: AppFontEintrachtOFCSans;\n\t  font-weight: 400;\n    }\n}\n.button-row {\n\tpadding: 10px 2px;\n\t&.eintracht {\n\t\tpadding-top: 20px;\n\t\tpadding-bottom: 20px;\n\t}\n}\n.cross-icon {\n\tz-index: 5;\n\tposition: absolute;\n\ttop: 15px;\n\tright: 15px;\n\n\tmargin: 0px;\n\tbackground: var(--color-white-accent);\n\twidth: 22px;\n\theight: 22px;\n\tpadding: 0px;\n\tz-index: 99;\n\tion-icon {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmargin: 0px;\n\t}\n}\n\n.eintracht {\n  --background: #282828;\n  --color: #fff;\n}\n\n.sum-container {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n}\nion-footer {\n\t&.eintracht{\n\t\tbackground: #282828;\n\t\tbox-shadow: none;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
